// MARK://dhk8/pos/features/reports/reports-hub-page
// Lista de reportes disponibles para gerencia. Cada tarjeta navega a
// /reports/view/:reportId (ReportDetailPage). Ported in spirit from
// sc-restaurant's ReportsPage / ReportsOperationalHub.
//
// Note: the existing /reports route (pages/ReportsPage.tsx) is the operational
// shift dashboard; this hub is the catalog of standalone report views. Sibling A
// should register /reports/hub + /reports/view/:reportId — see App.tsx TODO.

import { useNavigate } from 'react-router-dom'
import { BarChart3 } from 'lucide-react'

import { REPORT_CATALOG } from '../../lib/clients/reports.js'
import { reportsStyles } from './reports-styles.js'

export default function ReportsHubPage() {
  const navigate = useNavigate()
  return (
    <div className="dhk8-rpt">
      <header className="dhk8-rpt__head">
        <h1 className="dhk8-rpt__title">
          <BarChart3 size={18} className="dhk8-rpt__title-ico" aria-hidden />
          Reportes
        </h1>
        <p className="dhk8-rpt__sub">Reportes de gerencia con rango de fechas y exportación a CSV.</p>
      </header>

      <div className="dhk8-rpt__list">
        {REPORT_CATALOG.map((r) => (
          <button key={r.id} className="dhk8-rpt__item" onClick={() => navigate(`/reports/view/${r.id}`)}>
            <span className="dhk8-rpt__item-name">{r.name}</span>
            <span className="dhk8-rpt__item-desc">{r.description}</span>
          </button>
        ))}
      </div>

      <style>{reportsStyles}</style>
    </div>
  )
}
